module.exports = __webpack_public_path__ + "img/image_part_005.96b8a447.jpg";